<template>
  <div
    :class="$style.loading"
    :style="{
      fontSize: size ? `${size}px` : null,
      backgroundColor: backgroundColor,
      ['--loading-color']: color
    }"
  >
    <div :class="$style.spinner">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    size: {
      type: Number,
      default: null // default is set in scss
    },
    backgroundColor: {
      type: String,
      default: null // default is set in scss
    },
    color: {
      type: String,
      default: null // default is set in scss
    }
  }
};
</script>

<style module lang="scss">
@import "./Loading.scss";
</style>
